import { render, staticRenderFns } from "./closeButton.vue?vue&type=template&id=28f031da&scoped=true"
import script from "./closeButton.vue?vue&type=script&lang=js"
export * from "./closeButton.vue?vue&type=script&lang=js"
import style0 from "./closeButton.vue?vue&type=style&index=0&id=28f031da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f031da",
  null
  
)

export default component.exports